import EventsComp from "../../components/portal/events";

const Events = () => {
  return (
    <div className="container mx-auto px-4">
      <p className="text-3xl font-bold mb-2">Events</p>
      <p className="text-gold font-josefin text-xl mb-4">See what's upcoming</p>
      <EventsComp />
    </div>
  );
};

export default Events;
